import React from 'react'
import { useHistory } from "react-router-dom";
import cogoToast from "cogo-toast";
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";
import { Label, Input, Button, Card, CardBody, CardHeader, Row, Col, Alert } from "reactstrap";
import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { ListEmployeeApi } from "../../../../services/Api";
import { genericGet, genericPost } from "../../../../services/Api";
import { EbmsLoading, log } from "../../../../services/Utils";
import Select from 'react-select';
 

import { SUCCESS_RESULT,ENDPOINTS } from "../../../../Constants";
import { 
  FaTimes, 
  FaEdit, 
  FaFileExport, 
  FaUser, 
  FaPlusCircle, 
  FaTimesCircle, 
  FaSave, 
  FaAd, 
  FaHistory, 
  FaEye, 
  FaDollarSign,
  FaPercentage,
  FaCalendarAlt,
  FaBuilding,
  FaUserTie,
  FaTrash,
  FaCheckCircle,
  FaExclamationTriangle
} from "react-icons/fa";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
 
const CreateBudgetAllocations = () => {
  const toggle = () => setshowModal(!showModal);
  const toggle2 = () => setshow_alloc_details(!show_alloc_details);

  const [isLoading, setIsLoading] = useState(false);
 
  
  const history = useHistory();
  const [is_processing, setProcessing] = useState(false);
const [showModal, setshowModal] = useState(false)
 const [selected_staff, setselected_staff] = useState(null)
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);
  const [project_codes, setproject_codes] = useState([])
  const [selected_project, setselected_project] = useState(null)
  const [selected_line, setselected_line] = useState(null)
const [contracted_salary, setcontracted_salary] = useState(0)
const [amount, setamount] = useState(0)
const [percentage, setpercentage] = useState(0)
const [form_data, setForm_data] = useState({})
const [previous_allocs, setprevious_allocs] = useState([])
const [lines, setlines] = useState([])
const [year, setyear] = useState(null)
const [month, setmonth] = useState(null);
const [details_allocations, setDetails_allocations] = useState([])
const [show_alloc_details, setshow_alloc_details] = useState(false)
  useEffect(() => {
    fetch_data();
    loadProjects();
    
    return () => {};
  }, []);
  
  const updateData = e => {
    setForm_data({
        ...form_data,
        [e.target.name]: e.target.value
    })
}



const removeLine=(budget_line)=>{
  let _lines=lines;
  _lines=_lines.filter(function( obj ) {
    return obj.budget_line !== budget_line;
})
  setlines([]);
  setlines(_lines);

}


const get_detailed_alloc_total_percentage=()=>{

  let total=0;
  details_allocations.forEach((l)=>{
    total=Number(total)+Number(l.percentage);
  })
  return total?.toFixed(2);

}
const get_detailed_alloc_total_amount=()=>{

  let total=0;
  details_allocations.forEach((l)=>{
    total=Number(total)+Number(l.amount);
  })
  return total?.toFixed(2);

}

const get_prev_alloc_total_percentage=()=>{

  let total=0;
  previous_allocs.forEach((l)=>{
    total=Number(total)+Number(l.percentage);
  })
  return total?.toFixed(2);

}
const get_prev_alloc_total_amount=()=>{

  let total=0;
  previous_allocs.forEach((l)=>{
    total=Number(total)+Number(l.amount);
  })
  return total?.toFixed(2);

}
const get_prev_alloc_total_balance=()=>{

  let total=0;
  previous_allocs.forEach((l)=>{
    total=Number(total)+Number(l.deficit);
  })
  return total?.toFixed(2);

}
const add_budget=(e)=>{
  e.preventDefault();
 
  
  // validations
if(form_data?.project_id==null || form_data?.budget_line==null){
  cogoToast.error("Please Select Budget line " , {
    hideAfter: 5,
});
  return;
}

let line_exist=lines.filter(function( obj ) {
  return obj.budget_line == form_data?.budget_line;
});

if(line_exist?.length  > 0 ){
  cogoToast.error("Budget line already added  " , {
    hideAfter: 5,
});
  return;
}
if(!form_data?.amount>0){
  cogoToast.error("Amount should be greater than Zero. " , {
    hideAfter: 5,
});
return;
}


// if(Number(get_total_percentage())+Number(form_data?.percentage) > 100){
//   cogoToast.error("Percentage could not Exceed 100%  " , {
//     hideAfter: 5,
// });
// return;
// }




// END OF VALIDATIONS
let _lines=lines;


form_data.month=month;
form_data.year=year;

  setlines([]);
  _lines.push(form_data);
  setTimeout(() => {
 
    setlines(_lines);
    document.getElementById("form").reset();
    setForm_data(null)
  }, 100);
 
 

}

const  delete_allocation=(id)=>{
  setIsLoading(true);
  genericPost(ENDPOINTS.DELETE_ALLOCATION, {
    "allocation_id": id
   })
    .then((res) => {
      console.log(res)
      setIsLoading(false);
      if (res.status == 200) {
      
        if (res.data.status == SUCCESS_RESULT) {
          cogoToast.success("Allocation Deleted Successfully", {});
          get_previous_allocations(selected_staff?.staff_id);
          
        } else {
          cogoToast.error(res.data.message, {});
        }
      }
    })
    .catch((err) => {
      setIsLoading(false);
      console.log(err);
    });
}

const get_total_percentage=()=>{

  let total=0;
  lines.forEach((l)=>{
    total=Number(total)+Number(l.percentage);
  })
  return total?.toFixed(2);

}
const get_total_amount=()=>{

  let total=0;
  lines.forEach((l)=>{
    total=Number(total)+Number(l.amount);
  })
  return total?.toFixed(2);

}
const saveBudgetAllocation=()=>{
 
let data={
  staff_id:selected_staff?.staff_id,
  allocations:lines
}
 
setIsLoading(true);
genericPost(ENDPOINTS.CREATE_ALLOCATIONS, data)
  .then((res) => {
    setIsLoading(false);
    if (res.status == 200) {
      if (res.data.status == SUCCESS_RESULT) {
        let data = res.data.data;
        // clean-up
        setlines([])
        setshowModal(false);
        get_previous_allocations(selected_staff?.staff_id);
        console.log("Create-allocation Result",data)
        cogoToast.success(res.data.message, {});


   
      } else {
        cogoToast.error(res.data.message, {});
      }

    }

  })
  .catch((err) => {
    setIsLoading(false);
    console.log(err);
  });


}
const get_month_name=(month)=>{

  const date = new Date(year, month-1, 1);   
  const month_name = date.toLocaleString('default', { month: 'long' });
  return month_name;
 }
const get_allocation_details=(id,_month,_year)=>{
  setIsLoading(true);
  setshow_alloc_details(true);
  genericPost(ENDPOINTS.LIST_MONTHLY_ALLOCATIONS, {
    "staff_id": id,
    "month":_month ,
    "year": _year
   })
    .then((res) => {
      setIsLoading(false);
      if (res.status == 200) {
      
        if (res.data.status == SUCCESS_RESULT) {
          let responseData = res.data.data;
          setDetails_allocations(responseData)
        } else {
          cogoToast.error(res.data.message, {});
        }
      }
    })
    .catch((err) => {
      setIsLoading(false);
      console.log(err);
    });
}

const get_previous_allocations=(id)=>{
  setIsLoading(true);
  genericPost(ENDPOINTS.STAFF_ALLOCATIONS, {
    "staff_id": id
   })
    .then((res) => {
      setIsLoading(false);
      if (res.status == 200) {
      
        if (res.data.status == SUCCESS_RESULT) {
          let responseData = res.data.data;
          setprevious_allocs(responseData)
        } else {
          cogoToast.error(res.data.message, {});
        }
      }
    })
    .catch((err) => {
      setIsLoading(false);
      console.log(err);
    });
}

  const loadProjects = () => {
    setIsLoading(true);
    genericGet(ENDPOINTS.GET_PROJECT_CODES, {})
      .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {
        
          if (res.data.status == SUCCESS_RESULT) {
            let responseData = res.data.data;
            log("setproject_codes",responseData);
            // log("RIGHTS: ", responseData);
            setproject_codes(responseData)
          } else {
            cogoToast.error(res.data.message, {});
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const fetch_data = () => {
    setProcessing(true);
 

genericGet("hrm/ba/list-employees")
      .then((res) => {
         
        setProcessing(false);
        //gridRef.current.api.showLoadingOverlay();
        if (res.status == 200) {
          var response = res.data;
          console.log(JSON.stringify(res.data));
          if (response.status == SUCCESS_RESULT) {
            let _data = [];
            if (response.data?.length < 1) {
              alert("No Record ");
              return;
            }

            setRowData(response.data);
          } else {
            cogoToast.error(res.data.message, {
              hideAfter: 5,
            });
          }
        } else {
          {
            cogoToast.error(res.message, {
              hideAfter: 5,
            });
          }
          cogoToast.error(res.message, {
            hideAfter: 5,
          });
        }
      })
      .catch((err) => {
       
        setProcessing(false);
        console.log(err);
        cogoToast.error(err, {
          hideAfter: 5,
        });

        cogoToast.error("Something went wrong, please Try again.", {
          hideAfter: 5,
        });
      });
  };
  const defaultColDef = useMemo(() => {
    return {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: true,
      resizable: true,
    };
  }, []);


  return (
    <div className="container-fluid" style={{ padding: "20px" }}>
      {/* Header Section */}
      <Card className="shadow-sm mb-4">
        <CardHeader className="bg-primary text-white">
          <Row className="align-items-center">
            <Col md={10}>
              <h3 className="mb-0">
                <FaBuilding className="me-2" />
                Budget Allocations Management
              </h3>
              <small className="text-light">Manage staff budget allocations across projects</small>
            </Col>
            <Col md={2} className="text-end">
              {selected_staff && (
                <Button 
                  color="light" 
                  size="sm" 
                  onClick={() => setselected_staff(null)}
                  className="d-flex align-items-center"
                >
                  <FaTimes className="me-1" />
                  Close
                </Button>
              )}
            </Col>
          </Row>
        </CardHeader>
      </Card>

      <Row>
        {/* Staff Selection Grid */}
        <Col md={4}>
          <Card className="shadow-sm h-100">
            <CardHeader className="bg-light">
              <h5 className="mb-0">
                <FaUser className="me-2 text-primary" />
                Select Staff Member
              </h5>
            </CardHeader>
            <CardBody className="p-0">
              <div className="ag-theme-alpine" style={{ height: "500px" }}>
                <AgGridReact
                  suppressMenuHide={true}
                  ref={gridRef}
                  onGridReady={(params) => {
                    setGridApi(params.api);
                  }}
                  rowData={rowData}
                  domLayout={"autoHeight"}
                  animateRows={true}
                  onRowClicked={(e) => {
                    setshowModal(false);
                    setselected_staff(e.data);
                    setcontracted_salary(e.data.payroll_chargeable);
                    get_previous_allocations(e.data?.staff_id);
                  }}
                  pagination={true}
                  paginationPageSize={10}
                  defaultColDef={defaultColDef}
                  resizable={true}
                  enableCellTextSelection={true}
                  suppressCellSelection={true}
                  rowSelection="single"
                  columnDefs={[
                    {
                      headerName: "Staff Code",
                      field: "staff_code",
                      sortable: true,
                      filter: true,
                      maxWidth: 120,
                      cellClass: "fw-bold text-primary"
                    },
                    {
                      headerName: "Staff Name",
                      field: "staff_name",
                      sortable: true,
                      filter: true,
                      flex: 1
                    },
                    {
                      headerName: "Budgeted",
                      field: "budget_months",
                      sortable: true,
                      filter: true,
                      maxWidth: 100,
                      cellRenderer: (params) => (
                        <b> {params.value}  </b>
                      )
                    },
                    {
                      headerName: "Salary",
                      field: "payroll_chargeable",
                      sortable: true,
                      filter: true,
                      maxWidth: 120,
                      cellRenderer: (params) => (
                        <span className="text-success fw-bold">
                          ${Number(params.value).toLocaleString()}
                        </span>
                      )
                    }
                  ]}
                />
              </div>
            </CardBody>
          </Card>
        </Col>

        {/* Staff Details and Allocations */}
        <Col md={8}>
          {selected_staff ? (
            <>
              {/* Staff Information Card */}
              <Card className="shadow-sm mb-4">
                <CardHeader className="bg-gradient-primary text-white">
                  <Row className="align-items-center">
                    <Col>
                      <h5 className="mb-0">
                        <FaUserTie className="me-2" />
                        Staff Information
                      </h5>
                    </Col>
                    <Col className="text-end">
                      <Button 
                        color="success" 
                        size="sm" 
                        onClick={() => setshowModal(true)}
                        className="d-flex align-items-center"
                      >
                        <FaPlusCircle className="me-1" />
                        Add New Allocation
                      </Button>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md={6}>
                      <div className="mb-3">
                        <Label className="fw-bold text-muted">Staff Code</Label>
                        <div className="fs-5 text-primary">{selected_staff?.staff_code}</div>
                      </div>
                      <div className="mb-3">
                        <Label className="fw-bold text-muted">Full Name</Label>
                        <div className="fs-5">{selected_staff?.staff_name}</div>
                      </div>
                      <div className="mb-3">
                        <Label className="fw-bold text-muted">Role</Label>
                        <div>
                      
                      
                            {selected_staff?.role_name}
                        
                        
                        </div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <Label className="fw-bold text-muted">Office</Label>
                        <div className="fs-5">{selected_staff?.office_name}</div>
                      </div>
                      <div className="mb-3">
                        <Label className="fw-bold text-muted">Contracted Salary</Label>
                        <div className="fs-4 text-success fw-bold">
                          <FaDollarSign className="me-1" />
                          {Number(selected_staff?.payroll_chargeable).toLocaleString()}
                        </div>
                      </div>
                      <div className="mb-3">
                        <Label className="fw-bold text-muted">Contract End Date</Label>
                        <div className="fs-5">{selected_staff?.contract_end_date}</div>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              {/* Previous Allocations Card */}
              <Card className="shadow-sm">
                <CardHeader className="bg-light">
                  <h5 className="mb-0">
                    <FaHistory className="me-2 text-info" />
                    Previous Allocations
                  </h5>
                </CardHeader>
                <CardBody>
                  {previous_allocs.length > 0 ? (
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead className="table-light">
                          <tr>
                            <th><FaCalendarAlt className="me-1" />Month</th>
                            <th>Year</th>
                            <th><FaPercentage className="me-1" />Percentage</th>
                            <th><FaDollarSign className="me-1" />Amount</th>
                            <th>Deficit</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {previous_allocs.map((p, index) => (
                            <tr key={index}>
                              <td>
                              {p.month} 
                              </td>
                              <td className="fw-bold">{p.year}</td>
                              <td>
                                <span className="text-primary fw-bold">{p.percentage}%</span>
                              </td>
                              <td>
                                <span className="text-success fw-bold">
                                  ${Number(p.amount).toLocaleString()}
                                </span>
                              </td>
                              <td>
                                <span className={Number(p.deficit) > 0 ? "text-danger" : "text-success"}>
                                  ${Number(p.deficit).toLocaleString()}
                                </span>
                              </td>
                              <td>
                                <Button
                                  color="outline-primary"
                                  size="sm"
                                  onClick={() => get_allocation_details(selected_staff?.staff_id, p.month, p.year)}
                                >
                                  <FaEye />
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot className="table-light">
                          <tr className="fw-bold">
                            <td colSpan={2}>Total</td>
                            <td className="text-primary">{get_prev_alloc_total_percentage()}%</td>
                            <td className="text-success">${get_prev_alloc_total_amount()}</td>
                            <td className={Number(get_prev_alloc_total_balance()) > 0 ? "text-danger" : "text-success"}>
                              ${get_prev_alloc_total_balance()}
                            </td>
                            <td></td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  ) : (
                    <Alert color="info" className="text-center">
                      <FaExclamationTriangle className="me-2" />
                      No previous allocations found for this staff member.
                    </Alert>
                  )}
                </CardBody>
              </Card>
            </>
          ) : (
            <Card className="shadow-sm h-100">
              <CardBody className="d-flex align-items-center justify-content-center">
                <div className="text-center text-muted">
                  <FaUser className="display-4 mb-3" />
                  <h4>Select a Staff Member</h4>
                  <p>Choose a staff member from the list to view and manage their budget allocations.</p>
                </div>
              </CardBody>
            </Card>
          )}
        </Col>
      </Row>

      {/* Allocation Details Modal */}
      <Modal
        isOpen={show_alloc_details}
    
       className="modal-70w"
        onHide={() => setshow_alloc_details(false)}
        backdrop={true}
      >
        <ModalHeader toggle={toggle2}>
          <div className="row">
           
            Previous Allocations Details
          </div>
        </ModalHeader>
        <ModalBody>
          {isLoading && (
            <div className="text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-2">Please wait...</p>
            </div>
          )}

          {!isLoading && (
            <div className="table-responsive">
              <table className="table table-hover">
                <thead className="table-light">
                  <tr>
                    <th>Project</th>
                    <th>Budget</th>
                    <th>Budget Code</th>
                    <th>Created By</th>
                    <th><FaPercentage className="me-1" />Percentage</th>
                    <th><FaDollarSign className="me-1" />Amount</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {details_allocations?.map((p, index) => (
                    <tr key={index}>
                      <td className="fw-bold">{p.project_name}</td>
                      <td>{p.project_name}</td>
                      <td>
                     {p.budget_code} 
                      </td>
                      <td>{p.created_by}</td>
                      <td>
                        <span className="text-primary fw-bold">{p.percentage}%</span>
                      </td>
                      <td>
                        <span className="text-success fw-bold">
                          ${Number(p.amount).toLocaleString()}
                        </span>
                      </td>
                      <td>
                        <Button
                          color="outline-danger"
                          size="sm"
                          onClick={() => {
                            if(window.confirm("Are you sure to delete this allocation?")){
                              delete_allocation(p.id);
                            }
                          }}
                        >
                          <FaTrash />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot className="table-light">
                  <tr className="fw-bold">
                    <td colSpan={4}>Total</td>
                    <td className="text-primary">{get_detailed_alloc_total_percentage()}%</td>
                    <td className="text-success">${get_detailed_alloc_total_amount()}</td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          )}
        </ModalBody>
      </Modal>

      {/* Add New Allocation Modal */}
      <Modal
        isOpen={showModal}
        
       
        onHide={() => setshowModal(false)}
        backdrop={true}
        className="modal-70w"

      >
        <ModalHeader toggle={toggle}>
          <div className="row">
           
            Add New Allocations
          </div>
        </ModalHeader>
        <ModalBody>
          <Alert color="info" className="mb-4">
            <strong>Staff:</strong> {selected_staff?.staff_code} - {selected_staff?.staff_name} &nbsp;&nbsp;&nbsp; 
            <strong>Contracted Salary:</strong> <FaDollarSign className="me-1" />{contracted_salary}
          </Alert>

          <form onSubmit={add_budget} id="form">
            <Row>
              <Col md={4}>
                <div className="mb-3">
                  <Label className="fw-bold">
                    <FaCalendarAlt className="me-1" />
                    Month
                  </Label>
                  <select 
                    name="month"
                    className="form-control"
                    onChange={(e) => setmonth(e.target.value)}
                    required={true}
                  >
                    <option value=''>Select Month</option>
                    <option value={1}>January</option>
                    <option value={2}>February</option>
                    <option value={3}>March</option>
                    <option value={4}>April</option>
                    <option value={5}>May</option>
                    <option value={6}>June</option>
                    <option value={7}>July</option>
                    <option value={8}>August</option>
                    <option value={9}>September</option>
                    <option value={10}>October</option>
                    <option value={11}>November</option>
                    <option value={12}>December</option>
                  </select>
                </div>

                <div className="mb-3">
                  <Label className="fw-bold">Project</Label>
                  <Select
                    styles={{width:"100%"}}
                    value={{label:form_data?.project_name,value:form_data?.project_id}}
                    onChange={(e) => {
                      setForm_data({
                        ...form_data,
                        ["budget_line"]: "xx",
                        ["budget_name"]: "xx" 
                      })
                      setForm_data({
                        ...form_data,
                        ["project_id"]: e.value,
                        ["project_name"]: e.label 
                      })
                    }}
                    options={project_codes.map((p) => ({value: p.id, label: p.project_name}))}
                  />
                </div>
              </Col>

              <Col md={4}>
                <div className="mb-3">
                  <Label className="fw-bold">Year</Label>
                  <input 
                    className="form-control" 
                    name="year"   
                    value={year} 
                    onChange={(e) => setyear(e.target.value)} 
                    required={true}
                    type="number"
                    min="2020"
                    max="2030"
                  />
                </div>

                <div className="mb-3">
                  <Label className="fw-bold">Budget Line</Label>
                  <Select
                    styles={{width:"100%"}}
                    value={{label:form_data?.budget_name,value:form_data?.budget_line}}
                    onChange={(e) => {
                      setForm_data({
                        ...form_data,
                        ["budget_line"]: e.value,
                        ["budget_name"]: e.label
                      })
                    }}
                    options={project_codes.filter(function (p) {
                      return p.id == form_data?.project_id;
                    })[0]?.budget_codes?.map((line) => ({
                      value: line.id,
                      label: line.budget_line + " " + line.name
                    }))}
                  />
                </div>
              </Col>

              <Col md={4}>
                <div className="mb-3">
                  <Label className="fw-bold">
                    <FaPercentage className="me-1" />
                    Percentage (%)
                  </Label>
                  <input 
                    className='form-control' 
                    name="percentage"     
                    onChange={(e) => {
                      try {
                        let amt = (Number(e.target.value)/100) * Number(contracted_salary);
                        setForm_data({
                          ...form_data,
                          ["amount"]: amt,
                          ["percentage"]: e.target.value
                        })
                      } catch(e) { 
                        alert(e)
                      }
                    }}
                    type="number"
                    step="0.01"
                    min="0"
                    max="100"
                  /> 
                </div>

                <div className="mb-3">
                  <Label className="fw-bold">
                    <FaDollarSign className="me-1" />
                    Amount ($)
                  </Label>
                  <input 
                    className='form-control' 
                    name="amount"  
                    disabled={true} 
                    value={form_data?.amount?.toFixed(2)}
                    style={{backgroundColor: '#f8f9fa'}}
                  />  
                </div>

                <div className="mb-3">
                  <Button type='submit' className='btn btn-primary w-100'>
                    <FaPlusCircle className="me-1" />
                    Add Allocation
                  </Button> 
                </div>
              </Col>
            </Row>
          </form>

          {/* Selected Allocations Table */}
          <div className="mt-4">
            <h5 className="mb-3">
              <FaCheckCircle className="me-2 text-success" />
              Selected Allocations
            </h5>
            
            {lines.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead className="table-light">
                    <tr>
                      <th><FaCalendarAlt className="me-1" />Month</th>
                      <th>Year</th>
                      <th>Project</th>
                      <th>Budget Line</th>
                      <th><FaPercentage className="me-1" />Percentage</th>
                      <th><FaDollarSign className="me-1" />Amount</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {lines?.map((l, index) => (
                      <tr key={index}>
                        <td>
                      {l.month} 
                        </td>
                        <td className="fw-bold">{l.year}</td>
                        <td className="fw-bold">{l.project_name}</td>
                        <td>{l.budget_name}</td>      
                        <td>
                          <span className="text-primary fw-bold">{l.percentage}%</span>
                        </td>
                        <td>
                          <span className="text-success fw-bold">
                            ${Number(l.amount).toLocaleString()}
                          </span>
                        </td>
                        <td>
                          <Button
                            color="outline-danger"
                            size="sm"
                            onClick={(e) => removeLine(l.budget_line)}
                          >
                            <FaTimesCircle />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot className="table-light">
                    <tr className="fw-bold">
                      <td colSpan={4}>Total</td>
                      <td className="text-primary">{get_total_percentage()}%</td>
                      <td className="text-success">${get_total_amount()}</td>
                      <td></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            ) : (
              <Alert color="warning" className="text-center">
                <FaExclamationTriangle className="me-2" />
                No allocations added yet. Please add allocations above.
              </Alert>
            )}

            <div className="mt-3 text-end">
              <Button   
                className='btn btn-success btn-lg' 
                disabled={lines.length === 0}  
                onClick={() => saveBudgetAllocation()}
              >
                <FaSave className="me-2" />
                Save All Allocations
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default CreateBudgetAllocations